<template>
    <div id="autocomplete-results" v-if="isSearching || showNoResults || results.length">
        <ul v-if="!chosenTournament">
            <li v-if="isSearching">
                <span class="title">Searching...</span>
            </li>
            <li v-else-if="!results.length && !isSearching">
                <span class="title">No Results Found</span>
            </li>
            <li v-else v-for="result in results" :key="result.id" :id="result.id" @click="chooseTournament(result)" class="result">
                <span class="title">{{ result.name }}</span>
                <span class="location">{{ result.location }}</span>
                <template v-if="result.status === 'betting_open'">
                    <span class="status-open">Betting Open</span>
                </template>
                <template v-else>
                    <span class="status-closed">Betting Closed - View Odds</span>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                chosenTournament: false
            }
        },
        props: ['results', 'isSearching', 'showNoResults'],
        methods: {
            chooseTournament(tournament) {
                this.$parent.$emit('tournamentSelection', tournament);
                this.chosenTournament = true;
            }
        },
        watch: {
            isSearching(val, oldVal) {
                if(val !== oldVal && val === true) {
                    this.chosenTournament = false;
                }
            }
        }
    }
</script>

<style scoped>
    .result {
        cursor: pointer;
    }
</style>
